<!--
<div class="card card-outline card-primary">
  <div class="card-header text-center">
    <a [routerLink]="['/']" class="h1"><b>Admin</b>LTE</a>
  </div>
  <div class="card-body">
    <p class="login-box-msg">Sign in to start your session</p>

    <form (ngSubmit)="loginByAuth()" [formGroup]="loginForm">
      <div class="input-group mb-3">
        <input
          class="form-control"
          formControlName="email"
          placeholder="Email"
          type="email"
        />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-envelope"></span>
          </div>
        </div>
      </div>
      <div class="input-group mb-3">
        <input
          class="form-control"
          formControlName="password"
          placeholder="Password"
          type="password"
        />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-lock"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <div class="icheck-primary">
            <input id="remember" type="checkbox"/>
            <label for="remember"> Remember Me </label>
          </div>
        </div>
        &lt;!&ndash; /.col &ndash;&gt;
        <div class="col-5">
          <pf-button
            [block]="true"
            [disabled]="isFacebookLoading || isGoogleLoading"
            [loading]="isAuthLoading"
            [type]="'submit'"
          >
            Sign In
          </pf-button>
        </div>
        &lt;!&ndash; /.col &ndash;&gt;
      </div>
    </form>

    <div class="social-auth-links text-center mb-3">
      <pf-button
        (click)="loginByFacebook()"
        [block]="true"
        [disabled]="isAuthLoading || isGoogleLoading"
        [loading]="isFacebookLoading"
        class="mb-2"
      >
        <i class="fab fa-facebook mr-2"></i>
        Sign in using Facebook
      </pf-button>
      <pf-button
        (click)="loginByGoogle()"
        [block]="true"
        [disabled]="isAuthLoading || isFacebookLoading"
        [loading]="isGoogleLoading"
        theme="danger"
      >
        <i class="fab fa-google mr-2"></i>
        Sign in using Google+
      </pf-button>
    </div>

    <p class="mb-1">
      <a [routerLink]="['/forgot-password']">I forgot my password</a>
    </p>
    <p class="mb-0">
      <a [routerLink]="['/register']" class="text-center">
        Register a new membership
      </a>
    </p>
  </div>
  &lt;!&ndash; /.login-card-body &ndash;&gt;
</div>
-->
<!--<div class="back-ground">
<div class="con">
    <h5 class="text-center mb-1 h5">Login</h5>
    <div class="mt-2" style="border-color:#e9ecef !important;border:1px solid;padding: 10px;">
        <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
        <div class="form-group">
            <input type="text" autocomplete="nope" class="form-control" formControlName="username" id="username" placeholder="Email ID">
        </div>
        <div class="form-group">
            <div class="input-group">
                <input type="password" class="form-control" formControlName="password" placeholder="Password" id="password">
                <div class="input-group-append">
                    <span class="input-group-text rounded-0"><i class="fa fa-eye" id="eye" data-placement="top" title="Click to Show Password" aria-hidden="true"
                      (click)="togglePasswordVisibility()"
                      [ngClass]="{'fa-eye-slash': isPasswordVisible, 'fa-eye': !isPasswordVisible}" aria-hidden="true"></i></span>
                </div>
            </div>
        </div>
        <div class="text-center">
            <button type="submit" class="btn login-btn">Login</button>
        </div>
        <div class="text-center mt-2">
            <button type="button" class="btn login-btn" (click)="register()">Processor Register</button>
        </div>
        </form>
    </div>
</div>
</div>-->

<div class="container-fluid col-lg-10 col-12">
  <div class="row align-items-center">

    <!-- Left Column: Logo Image (order 1 on large, 2 on small) -->
<!-- Left Column: Logo -->
<div class="col-lg-6 col-md-6 col-12 order-md-2 mt-lg-5">
  <div class="text-center mt-lg-5">
        <img src="assets/img/Logo_1090%20462.png" class="img-fluid login-img mt-5" alt="Logo">
      </div>
    </div>

    <!-- Right Column: Login Form (order 2 on large, 1 on small) -->
    <div class="col-lg-6 col-md-6 col-12 order-md-1 mt-5 mb-lg-5">
      <div class="py-5 px-3 px-lg-5">
        <!-- Optional Logo -->
        <!-- <img src="assets/img/TF2T%20approved%20logo.png" class="img-fluid mb-4" style="height: 150px; width: 500px;"> -->

        <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
          <!-- Username -->
          <div class="form-group mt-5">
            <input type="text" autocomplete="off" class="form-control" formControlName="username" id="username" placeholder="Email ID">
          </div>

          <!-- Password with Eye Toggle -->
          <div class="form-group">
            <div class="input-group">
              <input type="password" class="form-control" formControlName="password" placeholder="Password" id="password">
              <div class="input-group-append">
                <span class="input-group-text rounded-0">
                  <i
                    class="fa"
                    [ngClass]="{'fa-eye-slash': isPasswordVisible, 'fa-eye': !isPasswordVisible}"
                    id="eye"
                    (click)="togglePasswordVisibility()"
                    title="Click to Show Password"
                    aria-hidden="true">
                  </i>
                </span>
              </div>
            </div>
          </div>

          <!-- Login Button -->
          <div class="text-center">
            <button type="submit" class="btn login-btn">Login</button>
          </div>

          <!-- Register Button -->
          <div class="text-center mt-2">
            <button type="button" class="btn login-btn" (click)="register()">Processor Register</button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>



<footer class="fixed-bottom py-2 mb-2" style="background-color: lightgoldenrodyellow;">
  <div class="container">
    <div class="row d-flex justify-content-center align-items-center text-center">
      
      <!-- Copyright Section -->
      <div class="col">
        <strong>
          <span>Copyright &copy; {{ currentYear }}</span>
          <a href="https://varnik.cloud" target="_blank" rel="noopener noreferrer" class="text-decoration-none">
            varnik.cloud
          </a>
        </strong>
        <span>. All rights reserved.</span>
      </div>

      <!-- Terms & Privacy Section -->
      <div class="col-auto">
        <p class="mb-0 fw-bold">
          <a [routerLink]="['/terms-condition']" target="_blank" class="text-decoration-none">Terms & Conditions</a>
          <span class="mx-2">|</span>
          <a [routerLink]="['/privacy-policy']" target="_blank" class="text-decoration-none">Privacy Policy</a>
        </p>
      </div>

    </div>
  </div>
</footer>
